export enum WidgetComponents {
  DATE_PICKER = 'date_picker',
  TIMEZONE_PICKER = 'timezone_picker',
  JOIN_WAITLIST_DIALOG = 'join_waitlist_dialog',
  PREMIUM_VIEWER_DIALOG = 'premium_viewer_dialog',
  FILTER = 'filter',
  AGENDA_ITEM = 'agenda_item',
  LOAD_MORE = 'load_more',
  DIALOG = 'dialog',
}
export const REFERRAL_INFO = 'daily_agenda_v2';

/**
 * Where a click that only navigates sent the visitor. Same string the service
 * list sends for its Service Page clicks (`onActionButtonClick.ts`), so the two
 * widgets can be counted together.
 */
export const SERVICE_PAGE_DESTINATION = 'service_page';
export const WIDGET_NAME = 'daily_agenda_v2';

export enum WidgetElements {
  BOOK_BUTTON = 'book_button',
  MONTH_ARROW = 'month_arrow',
  WEEK_ARROW = 'week_arrow',
  DATE_IN_MONTH = 'date_in_month',
  GO_TO_NEXT_AVAILABLE_DATE_LINK = 'go_to_next_available_date_link',
  CONFIRM_BUTTON = 'confirm_button',
  DROPDOWN = 'dropdown',
  CHECKBOX = 'checkbox',
  EXPAND = 'expand',
  COLLAPSE = 'collapse',
  COUNTER = 'counter',
  CHECKBOX_ALL = 'checkbox_all',
  FILTER_BUTTON = 'filter_button',
  CLEAR_BUTTON = 'clear_button',
  SHOW_ALL_SESSIONS_BUTTON = 'show_all_sessions_button',
  DIALOG_CLOSE_BUTTON = 'dialog_close_button',
  MENU_OPTION = 'menu_option',
  CHANGE_SERVICE_BUTTON = 'change_service_button',
  OPEN_FILTERS = 'open_filters',
  CLOSE_FILTERS = 'close_filters',
  FILTERS_ACCORDION_ITEM = 'filters_accordion_item',
  CLEAR = 'clear',
  FILTERS_ACCORDION_APPLY = 'filters_apply',
  FILTER_DROPDOWN_OPENED = 'filter_dropdown_opened',
  FILTER_DROPDOWN_CLOSED = 'filter_dropdown_closed',
  TIME_SLOT_NOTIFICATION = 'time_slot_notification',
  LOAD_MORE_BUTTON = 'load_more_button',
  DIALOG_CONFIRM_BUTTON = 'dialog_confirm_button',
  FILTERS_ACCORDION_OPENED = 'filters_accordion_opened',
  FILTERS_ACCORDION_CLOSED = 'filters_accordion_closed',
  TIMEZONE_CHANGE = 'timezone_change',
}

export enum TriggeredByOptions {
  INITIALIZE_WIDGET = 'initialize_widget',
  TIMEZONE_CHANGED = 'timezone_changed',
  DATE_SELECTED = 'date_selected',
  MONTH_SELECTED = 'month_selected',
  WEEK_SELECTED = 'week_selected',
  TIME_SELECTED = 'time_selected',
  FILTER_CHANGED = 'filter_changed',
}
